'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    DragItemTypes = require('../constants/DragItemTypes'),
    EditorSectionMixin = require('../mixins/EditorSectionMixin'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ImageCaption = require('./ImageCaption'),
    ImageSizes = require('../constants/ImageSizes'),
    EditorDragImages = require('../constants/EditorDragImages'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    update = require('react/lib/update'),
    { DragDropMixin, ImagePreloaderMixin, DropEffects } = require('react-dnd'),
    { PropTypes } = React;

require('./legacy/Section.less');

var EditorPoster = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin, createFlexibleImageQueueMixin(1)],

  className: 'editor-Section editor-Section--poster',

  propTypes: {
    uuid: PropTypes.string.isRequired,
    background: PropTypes.object,
    onDeleteClick: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  },

  getImageOptions() {
    return {
      image: this.props.background,
      mode: 'scale_crop',
      sizes: {
        thumb: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  getBackgroundDragPreviewUrl() {
    if (!this.props.background) {
      return;
    }

    var background = this.props.background,
        scale = this.getDragImageScale();

    return getThumbnailUrl(background, {
      mode: 'preview',
      width: Math.round(ImageSizes.EDITOR_POSTER_DRAG.width * scale),
      height: Math.round(ImageSizes.EDITOR_POSTER_DRAG.height * scale)
    });
  },

  getSectionDragPreviewUrl() {
    var scale = this.getDragImageScale(),
        image = EditorDragImages.POSTER;

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(image.size.width / image.intendedScale * scale),
      height: Math.round(image.size.height / image.intendedScale * scale)
    });
  },

  getImageUrlsToPreload() {
    return [
      this.getSectionDragPreviewUrl(),
      this.getBackgroundDragPreviewUrl()
    ];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.SECTION, {
      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
      dropTarget: this.getSectionDropTarget()
    });

    registerType(DragItemTypes.IMAGE, {
      dragSource: {
        canDrag() {
          return this.props.background &&
                 this.hasPreloadedImage(this.getBackgroundDragPreviewUrl());
        },

        beginDrag() {
          return {
            effectsAllowed: [DropEffects.MOVE],
            dragPreview: this.getPreloadedImage(this.getBackgroundDragPreviewUrl()),
            item: {
              image: this.props.background
            }
          };
        },

        endDrag(dropEffect) {
          if (dropEffect === DropEffects.MOVE) {
            DraftActionCreators.deleteSection(this.props.uuid);
          }
        }
      },

      dropTarget: {
        acceptDrop(item) {
          DraftActionCreators.updateSection(this.props.uuid, {
            background: item.image
          });
        }
      }
    });
  },

  componentDidMount() {
    if (this.props.isNew) {
      this.getDOMNode().scrollIntoViewIfNeeded();

      DraftActionCreators.resetLastAddedItem();
    }
  },

  componentDidUpdate(prevProps) {
    if (prevProps.background !== this.props.background) {
      this.updateImageQueue();
    }
  },

  render() {
    var backgroundStyle = {},
        sectionDragState = this.getDragState(DragItemTypes.SECTION),
        imageDragState = this.getDragState(DragItemTypes.IMAGE),
        imageDropState = this.getDropState(DragItemTypes.IMAGE),
        showBackground = this.props.background && !imageDragState.isDragging,
        caption;

    if (showBackground) {
      caption = this.props.background.caption;
      backgroundStyle.backgroundImage = this.getBackgroundImageUrl();
    }

    return (
      <div className={this.getClassName()}
           data-state={showBackground ? 'background' : 'empty'}
           data-dragging={sectionDragState.isDragging}
           data-hint={imageDropState.isDragging}
           data-hover={imageDropState.isHovering}
           {...this.dropTargetFor(DragItemTypes.IMAGE, DragItemTypes.SECTION)}>

        {this.renderLoaderImg()}

        <div className='editor-Section-topBar'
             {...this.dragSourceFor(DragItemTypes.SECTION)}>
          <div className='editor-Section-type'>
            <Icon name='poster' size='small' mode='stroke'/>
            <span className='editor-Section-typeTitle'>Fullscreen</span>
          </div>

          <div className='editor-Section-delete'
               onClick={this.handleDeleteClick}>
            <Icon name='cross' size='xsmall' mode='stroke' />
          </div>
        </div>

        <div className='editor-SectionHint'>
          <div className='editor-SectionHint-box'>
            <p className='editor-SectionHint-message utils--smallCaps'></p>
          </div>
        </div>

        {showBackground &&
          <div>
            <div className='editor-Section-background'
                 style={backgroundStyle}
                 {...this.dragSourceFor(DragItemTypes.IMAGE)}>
            </div>
            <ImageCaption text={caption}
                          onChange={this.handleCaptionChange} />
          </div>
        }
      </div>
    );
  },

  handeCaptionFocus() {
    this.setState({ isCaptionActive: true });
  },

  handeCaptionBlur() {
    this.setState({ isCaptionActive: false });
  },

  handleCaptionChange(textContent) {
    var background = update(this.props.background, {
      caption: { $set: textContent }
    });

    if (this.props.background.caption === textContent) {
      return;
    }

    DraftActionCreators.updateSection(this.props.uuid, {
      background: background
    });
  },

  handleDeleteClick() {
    this.props.onDeleteClick(this.props.uuid, !!this.props.background);
  }
});

module.exports = EditorPoster;



/** WEBPACK FOOTER **
 ** ./editor/EditorPoster.jsx
 **/